import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import {
  Label,
  LabelOff,
  Forward,
  Http,
  Code,
  Settings,
  Timer,
  Keyboard,
  HelpOutline,
  TouchApp,
  FlagOutlined,
} from "@material-ui/icons";

// Efecto interno del sistema (0383 FS-2.5).
// Deliberadamente NO parece un mensaje: esto es lo que hace el CRM por dentro, no lo que el
// cliente recibe. Confundir ambos planos es el error clásico de estos previsualizadores.

const ICONS = {
  tag: Label,
  removeTag: LabelOff,
  transferQueue: Forward,
  httpRequest: Http,
  openai: Code,
  setVariable: Settings,
  wait: Timer,
  typing: Keyboard,
  input: TouchApp,
  userReply: TouchApp,
  flowEnd: FlagOutlined,
};

const SimSideEffectCard = ({ step }) => {
  const theme = useTheme();
  const isDark = theme.palette.type === "dark";
  const effect = step.sideEffect || {};
  const Icon = ICONS[effect.type] || HelpOutline;

  const accent = effect.executed
    ? theme.palette.success.main
    : step.outcome === "skipped" || step.outcome === "error"
    ? theme.palette.warning.main
    : theme.palette.text.secondary;

  return (
    <Box
      display="flex"
      alignItems="flex-start"
      mb={1}
      style={{
        gap: 8,
        padding: theme.spacing(0.75, 1),
        borderRadius: 6,
        border: `1px dashed ${accent}`,
        backgroundColor: isDark ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)",
      }}
    >
      <Icon style={{ fontSize: 16, color: accent, marginTop: 2, flexShrink: 0 }} />
      <Typography variant="caption" style={{ color: theme.palette.text.secondary }}>
        {effect.description}
      </Typography>
    </Box>
  );
};

export default SimSideEffectCard;
